import { useQuery } from '@tanstack/react-query';
import { questKeys } from '../quests.keys';
import { hasClaimedQuest } from '../quests.service';
export const useHasClaimedQuest = (questId) => {
    return useQuery({
        queryKey: questKeys.hasClaimedQuest(questId),
        queryFn: () => hasClaimedQuest(questId),
        enabled: !!questId,
    });
};
